<div class="kz-video-container" [ngClass]="{'is-loading': ($playerIsLoaded | async), 'is-playing': ($playerIsPlaying | async)}" [ngStyle]="maxWidth && {'maxWidth': maxWidth}" >
  <button class="kz-video-play" [ngClass]="{'kz-video-play--small' : buttonSize == 'small'}" appGtmTrack="{{'video_play' + (!!gtmSuffix ? ('_'+ gtmSuffix) : '')}}" (click)="$playVideo.next(true)"><kz-icons name="play"></kz-icons></button>
  <ng-content></ng-content>
  <div class="kz-youtube-container" >
    <div class="kz-youtube-content" [ngStyle]="ratioContainer && {'paddingBottom': (ratioContainer * 100) + '%'}">
      <youtube-player *ngIf="video" [videoId]="video" [suggestedQuality]="(suggestedQuality) ? suggestedQuality: 'default'"></youtube-player>
    </div>
  </div>
</div>
